export default __webpack_public_path__ + "static/media/Tunic of the Usurper.4f420ed8.jpg";